import { isSmallScreenViewportUtil } from 'modules/viewport/utils.js'
import { createSelector } from 'reselect'

const isSmallScreenViewportSelect = createSelector(
  state => state && state.viewport,
  viewport => isSmallScreenViewportUtil(viewport)
)

export default isSmallScreenViewportSelect
